module.exports = __webpack_public_path__ + "static/media/watson.af2c9e86.ttf";